import { Component, Input } from '@angular/core';

@Component({
    selector: 'gl-cards-page-layout-container',
    templateUrl: './cards-page-layout-container.component.html'
})
export class CardsPageLayoutContainerComponent {
    @Input() secondMainAreaEnabled = false;
}
